import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncRepReqTable, IEncRepReqTableReduxProps } from '../../types/interfaces';

import EncRepReqAnswer from './EncRepReqAnswer';
import BienCard from '../bien_card/BienCardInfo';
import TableContainer from "../tables_manager/TableContainer"
import { SelectColumnFilter, NumberRangeColumnFilter, DateRangeColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faExternalLinkAlt, faEye, faFileInvoice, faMoneyCheck, faPen, faQuestionCircle, faReceipt, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';
import EncaissementScanModal from '../encaissement_list/EncaissementScanModal';
import PDFLink from '../pdf/PDFLink';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'

const EncRepReqTable = ({ 
  linesData,
  user,
  auth
 }: IEncRepReqTable) => {
  const history = useHistory();
  const alert = useAlert();
  const {users} = user
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [answer, setAnswer] = useState(-1);
  
  const [modalViewer, setModalViewer] = useState(false);
  const [modalEncaissementViewer, setModalEncaissementViewer] = useState<any>('');

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        hidden: true
      },
      {
        Header: "ID Vente",
        accessor: "venteId",
        hidden: true
      },
      {
        Header: "ID Bien",
        accessor: "bienId",
        hidden: true
      },
    {
      Header: "Aperçus",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
        <div className="actionsContainer">
          <PDFLink documentType={"vente"}
            func={async () => getVenteByIdPromise(original.venteId || -1)}
            download={false}
            buttonText=""
            iconSize="inherit"
            // customClassNames="btn btn-info"
            customButtonIcon={faFileInvoice}
            allowPrintPreview={true}
            htmlTitle={`Voir la fiche de Vente`}
            customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
            style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
          <PDFLink documentType={"decharge"}
            data={original}
            download={false}
            buttonText=""
            iconSize="inherit"
            // customClassNames="btn btn-info"
            customButtonIcon={faReceipt}
            allowPrintPreview={true}
            largeModal
            htmlTitle={`Voir le décharge`}
            customClassNames="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
            style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />
        </div>
      ),
    },
      {
        Header: "Projet",
        accessor: e => e.contrat?.PROJET || "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "N° Doss.",
        accessor: e => e.contrat?.NUM_DOSS || "",
        filter: 'equals',
        className: "text-center",
        Cell: ({ value, row: {original} }) => <a href={original.venteId !== null && original.venteId !== undefined ? (`/consultation/${original.venteId}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(original.venteId !== null && original.venteId !== undefined)
            window.open('/consultation/' + original.venteId,'_blank')
          else
            alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
        }}><button className="openLinkBtn">{value || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>
      },
      {
        Header: "Commentaire",
        accessor: "comment",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Demandée par",
        accessor: e => (e.reqBy && users?.find(t => t.id === e.reqBy))?.username || "",
        Cell: ({ value, row: {original} }) => `${value || "-"}, le ${original.reqAt ? moment(original.reqAt).format('DD/MM/YYYY') : "-"}`
      },
      {
        Header: "Demandée le",
        accessor: "reqAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.reqAt ? new Date($.reqAt) : "-"`,
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
        hidden: true
      },
      {
        Header: "Encaissements Remplacés",
        customExportDisplay: `($.enc_sorti_lines || []).filter(e => !e.isReplacer).map(e => e.encaissement).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? e.id : "-").join(" / ")`,
        accessor: row => row.enc_sorti_lines?.filter(e => !e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
        filter: (rows, id, e) => rows.filter(t => (t.values?.[id?.[0]] || []).filter(m => m.REF_REGLEMENT?.toLowerCase().includes((e || "").toLowerCase().trim())).length),
        disableSortBy: true,
        Cell: ({ value }) => value?.length ? <>
          {value.map(e => e ? <div className="tableCellBlocks" style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "10px"}}>
            <div>#{e.id}</div>
            <div style={{whiteSpace: "nowrap", flex: 1}}>
              Réf: {e.REF_REGLEMENT}
            </div>
            {!!(e.recto_name || e.verso_name || e.URL || e.URL_VERSO) && <FontAwesomeIcon icon={faMoneyCheck} style={{cursor: "pointer", color: "orangered"}} onClick={() => (setModalEncaissementViewer(e), setModalViewer(true))} />}
          </div> : null)}
          <div className="fullFlexCenter"><b style={{color: "orangered"}}>Total:&nbsp;</b>{value.reduce((e, t) => e + Number(t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </> : "-"
      },
      {
        Header: "Encaissements Attachés",
        customExportDisplay: `($.enc_sorti_lines || []).filter(e => e.isReplacer).map(e => e.encaissement).filter((value, index, self) => (!value || value.id === undefined) || self.findIndex(e => (e ? e.id : undefined) === (value ? value.id : undefined)) === index).map(e => e ? e.id : "-").join(" / ")`,
        accessor: row => row.enc_sorti_lines?.filter(e => e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || [],
        filter: (rows, id, e) => rows.filter(t => (t.values?.[id?.[0]] || []).filter(m => m.REF_REGLEMENT?.toLowerCase().includes((e || "").toLowerCase().trim())).length),
        disableSortBy: true,
        Cell: ({ value }) => value?.length ? <>
          {value.map(e => e ? <div className="tableCellBlocks" style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "10px"}}>
            <div>#{e.id}</div>
            <div style={{whiteSpace: "nowrap", flex: 1}}>
              Réf: {e.REF_REGLEMENT}
            </div>
            {!!(e.recto_name || e.verso_name || e.URL || e.URL_VERSO) && <FontAwesomeIcon icon={faMoneyCheck} style={{cursor: "pointer", color: "cornflowerblue"}} onClick={() => (setModalEncaissementViewer(e), setModalViewer(true))} />}
          </div> : null)}
          <div className="fullFlexCenter"><b style={{color: "cornflowerblue"}}>Total:&nbsp;</b>{value.reduce((e, t) => e + Number(t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </> : "-"
      },
      {
        Header: "Validation",
        accessor: e => e.valid === 0 ? "Refusée" : e.valid === 1 ? "Acceptée" : "Pas encore",
        Filter: SelectColumnFilter,
        filter: 'equals',
        Cell: ({ value, row: {original} }) => <div style={{fontWeight: 600, color: original.valid === 0 ? "darkred" : original.valid === 1 ? "green" : "black"}}>{value}</div>
      },
      {
        Header: "Validée par",
        accessor: e => (e.valid !== -1 && e.validBy && users?.find(t => t.id === e.validBy))?.username || "",
        Cell: ({ value, row: {original} }) => original.valid !== -1 ? `${value || "-"}, le ${original.validAt ? moment(original.validAt).format('DD/MM/YYYY') : "-"}` : "-"
      },
      {
        Header: "Validée le",
        accessor: e => e.valid !== -1 ? e.validAt : "",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.valid != -1 && $.validAt ? new Date($.validAt) : "-"`,
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-",
        hidden: true
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                {row.original.valid !== 1 ? <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => answerButton(1, row.original)}
                  title="Accepter">
                  <FontAwesomeIcon icon={faCheck} />
                </button> : null}
                {row.original.valid !== 1 ? <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => answerButton(0, row.original)}
                  title="Refuser">
                  <FontAwesomeIcon icon={faTimes} />
                </button> : null}
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );

  const answerButton = (answer, data) => {
    if(answer === 1){
      const replacedList = (data.enc_sorti_lines || []).filter(e => !e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index)
      const replacerList = (data.enc_sorti_lines || []).filter(e => e.isReplacer).map(e => e.encaissement).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index)
      if(replacedList.length && replacerList.length){
        let found: any = null
        for(let i in replacedList){
          if(replacedList[i].MODE_REGL !== constants.MODE_REGL_CHEQUE)
            continue
          for(let j in replacerList){
            if(replacerList[j].MODE_REGL !== constants.MODE_REGL_CHEQUE)
              continue
            let replacedDateToTake, saisieIsAfter = false
            if(moment(replacedList[i].createdAt).isAfter(moment(replacedList[i].DATE_REGLEMENT))){
              replacedDateToTake = moment(replacedList[i].createdAt)
              saisieIsAfter = true
            }
            else{
              replacedDateToTake = moment(replacedList[i].DATE_REGLEMENT)
              saisieIsAfter = false
            }
            if(replacedDateToTake.isBefore(moment(replacerList[j].createdAt).subtract(1, 'months'))){
              found = {replacedDateToTake, saisieIsAfter, replaced: replacedList[i], replacer: replacerList[j]}
              break
            }
          }
        }
        if(found){
          let isGood = false
          if(replacerList.reduce((e, t) => e + Number(t.MONTANT || 0), 0) >= replacedList.reduce((e, t) => e + Number(t.MONTANT || 0), 0) && replacerList.every(e => e.MODE_REGL !== constants.MODE_REGL_CHEQUE || moment(e.DATE_REGLEMENT).isSameOrBefore(moment().add(1, 'month'))))
            isGood = true
          if(!isGood){
            alert.error(`La date saisie du remplaçant (${found.replacer?.REF_REGLEMENT} - ${moment(found.replacer?.createdAt).format('DD/MM/YYYY')}) dépasse 1 mois la date de${found.saisieIsAfter ? " saisie de" : ""} l'encaissement remplacé (${found.replaced?.REF_REGLEMENT} - ${found.replacedDateToTake?.format('DD/MM/YYYY')})`);
            if(!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER))
              return
          }
        }
      }
    }
    setAnswer(answer);
    setModalData(data);
    setModal(true)
  }
  
  return <>
    <Container>
      <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
    </Container>
    <EncRepReqAnswer modal={modal} setModal={setModal} modalData={modalData} answer={answer} />
    <EncaissementScanModal modal={modalViewer} setModal={setModalViewer} modalEncaissement={modalEncaissementViewer} setModalEncaissement={setModalEncaissementViewer} />
  </>
};

const mapStateToProps = (state: IEncRepReqTableReduxProps) => ({
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(EncRepReqTable);
